/** Pick first defined balance value; treats 0 as valid (unlike ||). */
export function pickBalance(...values) {
  for (const value of values) {
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }
  return 0;
}

export function getFormattedBalance(balance) {
  if (balance !== undefined && balance !== null && balance !== "") {
    if (typeof balance === "number") return balance.toLocaleString();
    if (typeof balance === "string" && !balance.includes(",")) {
      if (balance.includes(".")) return balance;
      const intBalance = parseInt(balance, 10);
      if (!Number.isNaN(intBalance)) return intBalance.toLocaleString();
    }
  }
  return "0";
}
